

export default {
    install: async (Vue) => {
    // Set dictionaries on prototipe, for global use
        Vue.prototype.$rules = {
            email: [
                v => !!v || 'Correo es requerido.',
                v => /.+@.+/.test(v) || 'Correo no válido.',
                v => v.length >= 4 || 'Almenos 6 caracteres.'
            ],
            ciRequired: v => !!v || 'El campo ci es requerido.',
            nacRequired: v => !!v || 'La fecha de nacimiento es requerida.',
            ci: [
                //-v => v.length >= 5 || 'Se espera al menos 5 digitos'
                v => {
                    if (v) {
                        if (v.length >= 5) {
                            return true
                        }
                        else {
                            return 'Se espera al menos 5 digitos.'
                        }
                    }
                    else {
                        return 'Este campo es requerido.'
                    }
                }
            ],
            fileDec: [
                v => !!v || 'El archivo .dec es requerido.'
            ]
        }
    },
}
